import React from 'react';

interface BrandLogoProps {
    fontSize?: string;
    style?: React.CSSProperties;
    textColor?: string;
    greyColor?: string;
    onClick?: () => void;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({ 
    fontSize = '24px', 
    style,
    textColor = '#000',
    greyColor = '#888',
    onClick
}) => {
    return (
        <div 
            onClick={onClick}
            style={{ 
            fontFamily: '"Nunito Sans", sans-serif', 
            fontSize, 
            lineHeight: '1', 
            display: 'flex', 
            alignItems: 'center',
            ...style 
        }}>
            <span style={{ fontWeight: 800, color: textColor }}>inventure</span>
            <span style={{ fontWeight: 300, color: greyColor }}>capital</span>
        </div>
    );
};
